<script>
export default {
    name: 'BasePaymentRadioInput',
    props: {
        titleText: {
            type: String,
            required: true,
        },
        subtitleText: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        selectedPaymentMethod: {
            type: Number,
            required: false,
            default: null,
        },
        numericValue: {
            type: Number,
            required: true,
        },
        logo: {
            type: Object,
            required: false,
            default: null,
        },
        updateValue: {
            type: Function,
            required: true,
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.selectedPaymentMethod;
            },
            set(value) {
                this.updateValue(value);
            },
        },
    },
};
</script>

<template>
    <div class="flex items-center relative">
        <input
            :id="`payment-method-${name}`"
            v-model="computedValue"
            type="radio"
            name="payment-method"
            :value="numericValue"
            class="payment-radio-input"
        />

        <label
            :for="`payment-method-${name}`"
            class="p-4.5 lg:py-9 lg:px-5 bg-white rounded-3xl flex flex-col lg:flex-row text-sm lg:items-center justify-between w-full border hover:border-blue-100 border-grey-50 transition"
        >
            <span class="flex flex-col">
                <span class="font-Source-Sans-Pro-Bold mb-2 leading-5 text-base">
                    {{ titleText }}
                </span>
                <span class="font-Source-Sans-Pro-Regular">
                    {{ subtitleText }}
                </span>
            </span>
        </label>

        <a v-if="logo" class="absolute right-8" :href="logo.url" target="_blank">
            <img class="w-[136px] h-auto" :src="logo.img" :alt="logo.alt" />
        </a>
    </div>
</template>

<style scoped>
.payment-radio-input {
    & + label {
        @apply transition-all cursor-pointer;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.12);
    }

    &:checked {
        & + label {
            @apply border-opacity-100 border-blue-100;
            box-shadow: inset 0 0 0 5px rgba(74, 144, 226, 0.4);
        }
    }
}
</style>
